// extracted by mini-css-extract-plugin
module.exports = {"root":"FileHistory_root_2miJO","title":"FileHistory_title_2j58E","inner":"FileHistory_inner_1fca_"};